var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "64", height: "64", viewBox: "0 0 64 64" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { fill: "#767676", d: "M24 12.036V15h4v-4.01h8V15h4v-2.964C40 9.807 38.402 8 36.43 8h-8.86C25.599 8 24 9.807 24 12.036z" }),
      React.createElement("path", { fill: "#B2B2B2", d: "M8 15h48c2.21 0 4 1.79 4 4v33c0 2.21-1.79 4-4 4H8c-2.21 0-4-1.79-4-4V19c0-2.21 1.79-4 4-4z" }),
      React.createElement("path", { fill: "#E0E0E0", d: "M8 15h48c2.21 0 4 1.79 4 4v10.026c0 .919-.626 1.72-1.517 1.94l-25.46 6.338c-.634.157-1.296.158-1.929 0L5.52 30.967C4.627 30.745 4 29.944 4 29.025V19c0-2.21 1.79-4 4-4z" }),
      React.createElement("path", { fill: "#FFF", d: "M29 32h6c.552 0 1 .448 1 1v6c0 2.21-1.79 4-4 4s-4-1.79-4-4v-6c0-.552.448-1 1-1z" })
    )
  );
});